// extracted by mini-css-extract-plugin
export default {"sectionHead":"ClientPackagesSection_sectionHead__KjVYd","emptyState":"ClientPackagesSection_emptyState__b8KRu"};